import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { CollapsibleContentSmall } from '../../../Collapsible';
import { Section } from '../../../Section';
import { ArticleCard } from '../../ArticleCard';
import { MainColumn, Three } from '../partials';
var FEATURED_ARTICLES_QTY = 3;
var FTopicSection = function FTopicSection(_ref) {
  var tag = _ref.tag,
    _ref$articlesQty = _ref.articlesQty,
    articlesQty = _ref$articlesQty === void 0 ? 9 : _ref$articlesQty,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? true : _ref$withTitle,
    titleProp = _ref.title,
    _ref$collapsable = _ref.collapsable,
    collapsable = _ref$collapsable === void 0 ? false : _ref$collapsable,
    _ref$withAuthor = _ref.withAuthor,
    withAuthor = _ref$withAuthor === void 0 ? false : _ref$withAuthor,
    _ref$onlyWithImage = _ref.onlyWithImage,
    onlyWithImage = _ref$onlyWithImage === void 0 ? false : _ref$onlyWithImage,
    _ref$articlesIsClient = _ref.articlesIsClient,
    articlesIsClient = _ref$articlesIsClient === void 0 ? false : _ref$articlesIsClient;
  var articlesInput = tag.articles;
  var articles = articlesInput.filter(function (_ref2) {
    var title = _ref2.title;
    return title.length < 120;
  });
  var articlesWithImage = articles.filter(function (_ref3) {
    var image = _ref3.image;
    return Boolean(image);
  });
  var featuredArticle = articlesWithImage.slice(0, FEATURED_ARTICLES_QTY);
  var otherArticles = articles.filter(function (item) {
    return !featuredArticle.map(function (_ref4) {
      var id = _ref4.id;
      return id;
    }).includes(item.id);
  }).slice(0, articlesQty - FEATURED_ARTICLES_QTY);
  return React.createElement(Section, {
    bottomMargin: bottomMargin,
    title: withTitle ? titleProp : null
  }, React.createElement(MainColumn, null, React.createElement(Three, null, featuredArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "medium",
      article: article,
      withImage: true,
      withAuthor: withAuthor,
      withDate: false,
      maxTitleLength: 100,
      isClient: articlesIsClient
    });
  }))), !otherArticles.length ? null : collapsable ? React.createElement(CollapsibleContentSmall, {
    collapsed: true,
    title: "Ver m\xE1s",
    titlePosition: "bottom",
    chevronWidth: "3",
    chevronPosition: "right",
    color: "linkColor"
  }, !onlyWithImage && React.createElement(MainColumn, null, React.createElement(Three, null, otherArticles.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "small",
      article: article,
      withImage: false,
      withDate: false,
      withAuthor: false,
      withDescription: true,
      isClient: articlesIsClient
    });
  })))) : !onlyWithImage && React.createElement(MainColumn, null, React.createElement(Three, null, otherArticles.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "small",
      article: article,
      withImage: false,
      withDate: false,
      withAuthor: false,
      withDescription: true
    });
  }))));
};
export default FTopicSection;